import React, { FC } from 'react';
import { NewsroomFeaturedPrimaryProps } from './types';
import { getImagePath } from '../../utilities/path';
import { AutomationPlacement, AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from '../../utilities/automation';
import Picture from '../Picture';

const NewsroomFeaturedPrimary: FC<NewsroomFeaturedPrimaryProps> = ({ article }) => {
  const primaryTestId = createDataTestId({placement: AutomationPlacement.NEWSROOM_ARCHIVE_PAGE, feature: AutomationTestIdFeature.NEWSROOM_FEATURED, element: AutomationTestIdElementType.COLLECTION_ITEM, specifier: 'PrimaryFeature'});
  return (
    <div className="row align-items-center" data-test-id={primaryTestId}>
      <div className="px-xl-6 px-lg-5 px-4 col-lg">
        {article.imageSrc ? <Picture src={getImagePath(article.imageSrc)} alt={article.imageAlt} style={{ maxWidth: '100%' }} /> : null}
      </div>
      <div className="pl-lg-0 pr-xl-6 pr-lg-5 px-4 mt-3 mt-lg-0 col-lg">
        <h2 className="align-middle text-primary">{article.title}</h2>
        <a href={`/${article.path}`} className="btn btn-primary py-2 mt-4">Read more</a>
      </div>
    </div>
  );
};

export default NewsroomFeaturedPrimary;
